import store from "@/store"
import { AccountService } from "@/services"

/**
 * Check if role is "admin"
 * @param {*} role
 * @returns
 */
export function isAdmin(role) {
  return role === "administrator"
}

/**
 * Check if role is at least "inspector"
 * @param {*} role
 * @returns
 */
export function isInspector(role) {
  return role === "administrator" || role === "inspector"
}

/**
 * Check if role is "operator"
 * @param {*} role
 * @returns
 */
export function isOperator(role) {
  return role === "operator"
}

/** Logout user */
export const logout = (to, from, next) => {
  AccountService.logout()
  return next({ name: "SignIn" })
}

/** Require User to be authenticated */
export const requireAuth = (to, from, next) => {
  if (store.state.app.user?.key) return next()
  else return next({ name: "SignIn", query: { redirect: to.fullPath } })
}

/** Require User to be administrator */
export const requireAdmin = (to, from, next) => {
  if (store.getters["app/isUserAdmin"]) return next()
  else return next({ name: "Home" })
}

/** Require User to be owner of company */
export const requireCompanyOwner = (to, from, next) => {
  if (store.getters["app/isCompanyOwner"]) return next()
  else return next({ name: "Home" })
}

/** Require User to be inspector on project */
export const requireInspector = (to, from, next) => {
  if (store.getters["app/hasSelectedProject"] && isInspector(store.state.app.project.role)) {
    return next()
  } else return next({ name: "Home" })
}

/** Require User to be staff member A.K. administrator */
export const requireStaff = (to, from, next) => {
  if (store.getters["app/isUserStaff"]) return next()
  else return next({ name: "Home" })
}

/** Require company to be defined */
export const requireCompany = (to, from, next) => {
  if (store.getters["app/getCompany"] !== -1) return next()
  else return next({ name: "SelectCompany", query: { redirect: to.fullPath } })
}

/** Require project to be defined */
export const requireProject = (to, from, next) => {
  if (store.getters["app/getCompany"] !== -1 && store.getters["app/hasSelectedProject"]) {
    return next()
  } else return next({ name: "Projects" })
}

// /** Require pcqLiner to be defined */
// export const pcqLiner = (to, from, next) => {
//   if (store.getters["app/getCompany"] !== -1) {
//     return next()
//   } else return next({ name: "Projects" })
// }
